import { alpha, styled } from '@mui/material/styles';
import { InputBase } from "@mui/material";

const WhiteInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(2),
        color: '#707070',
    },
    '& .MuiInputBase-input': {
        borderRadius: 10,
        position: 'relative',
        border: '1px solid #B8B8B8',
        fontSize: 16,
        background: '#343434',
        padding: '10px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.25rem`,
            borderColor: theme.palette.primary.main,
        },
        '&:-webkit-autofill': {
            "-webkit-box-shadow": "0 0 0 100px var(--primary-weak) inset",
            "-webkit-text-fill-color": "#707070",
        },
        '&.Mui-focused': {
            backgroundColor: 'transparent',
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
        },
        '&.Mui-disabled, &:read-only': {
            backgroundColor: '#565656',
            border: '1px solid #5f5f5f',
            color: '#B8B8B8',
        }
    },
}));

export { WhiteInput }